/*=========================================================================================
  File Name: moduleDeviceActions.js
  Description: Device Module Actions
==========================================================================================*/

import axios from "@/axios.js"

export default {
    fetchDevice({ commit }, UUID) {
        return new Promise((resolve, reject) => {
            axios.get(`/api/device-management/devices/${UUID}`)
                .then((response) => {
                    commit('SET_DEVICE', response.data)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    fetchDeviceStatus({ commit }) {
        return new Promise((resolve, reject) => {
            let deviceStatus = "DEVICE_STATUS"
            axios.get(`/api/common-code-management/code-group/${deviceStatus}`)
                .then((response) => {
                    commit('SET_DEVICE_STATUS', response.data)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    updateDeviceStatus({ commit }, deviceInfo) {
        return new Promise((resolve, reject) => {
            axios.put(`/api/device-management/devices/status`, deviceInfo)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    fetchUsedSubscribe({ commit }) {
        return new Promise((resolve, reject) => {
            let usedSubscribe = "USED_SUBSCRIBE"
            axios.get(`/api/common-code-management/code-group/${usedSubscribe}`)
                .then((response) => {
                    commit('SET_USED_SUBSCRIBE', response.data)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    updateUsedSubscribe({ commit }, deviceInfo) {
        return new Promise((resolve, reject) => {
            axios.put(`/api/device-management/devices/status`, deviceInfo)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    updateDeviceUUID({ commit }, deviceInfo) {
        return new Promise((resolve, reject) => {
            axios.post(`/api/device-management/devices/${deviceInfo.deviceUUID}/${deviceInfo.deviceSecurityKey}`)
                .then((response) => {
                    if (response.data.resultCode === 303 && response.data.resultMessage === "DUPLICATE_ID") {
                        reject('DUPLICATE_DEVICE_UUID_MESSAGE')
                    } else if (response.data.resultCode === 300) {
                        reject('INSERT_ERROR')
                    }
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    updateDeviceUUIDByExcel({ commit }, deviceInfo) {
        return new Promise((resolve, reject) => {
            axios.post(`/api/device-management/devices/${deviceInfo.fileName}`, deviceInfo.deviceUUIDList)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    }

}